import React, { useState } from "react";
import TabsHeadingApplication from "../components/Tabs/TabsheadingApplication";
import { ApplicationForm } from "./ApplicationForm";
import { ApplicationQr } from "./ApplicaionQr";

const Application = () => {
  const listtoeknization = ["upload certificates", "one-click apply"];
  const [actTab, setActTab] = useState("upload certificates");

  return (
    <div>
      <TabsHeadingApplication
        list={listtoeknization}
        actTab={actTab}
        setActTab={setActTab}
      />

      {actTab === "upload certificates" ? (
        <ApplicationForm />
      ) : (
        <ApplicationQr />
      )}
      
      {/* Test link for the new jobs route */}
      {/* <div className="text-center mt-4 mb-4">
        <p className="text-muted">
          <small>Test the new jobs page:</small>
        </p>
        <a 
          href="/jobs/job-123" 
          className="btn btn-outline-secondary btn-sm me-2"
          target="_blank"
          rel="noopener noreferrer"
        >
          Test Jobs Page (Job-123)
        </a>
        <a 
          href="/jobs/job-2025" 
          className="btn btn-outline-secondary btn-sm"
          target="_blank"
          rel="noopener noreferrer"
        >
          Test Jobs Page (Job-2025)
        </a>
      </div> */}
    </div>
  );
};

export default Application;
